import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'eighth-note',
  size: 24,
  node: [
    ['path', { d: 'm19 6-5.2-3.9a.5.5 0 0 0-.8.4V18', key: 'nsdg4r' }],
    ['circle', { cx: '9', cy: '18', r: '4', key: '1972g7' }],
  ],
  aliases: ['music-2'],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name EighthNote
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTkgNi01LjItMy45YS41LjUgMCAwIDAtLjguNFYxOCIgLz4KICA8Y2lyY2xlIGN4PSI5IiBjeT0iMTgiIHI9IjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/eighth-note
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EighthNote = createLucideIcon(__iconData);

export default EighthNote;
